import React, { useEffect, useState } from "react";
import orderApi from "../../../services/apiServices/orderApi";
import "./PaymentConfirmationPage.css";
import { setLoading } from "../../../services/redux/loadingSlice";
import { useDispatch } from "react-redux";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { useNavigate, useParams } from "react-router-dom";
import ArrowIcon from "../../../components/icons/ArrowIcon";

const PaymentConfirmationPage = () => {
    const [order, setOrder] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                dispatch(setLoading(true));
                const response = await orderApi.getOrderByNumber(id, {
                    include: "Customer,Customer.CustomerType,Customer.User,Customer.User.Address,Customer.User.Address.City,OrderHistory,OrderTransaction"
                });
                setOrder(response); 
            } catch (err) {
                console.error("Error fetching order:", err);
                setError("Erro ao carregar pedido. Tente novamente.");
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchOrder();
    }, [dispatch, id]);

    if (error) {
        return <p className="payment-confirmation-error-message">{error}</p>;
    }

    if (!order) {
        return <p className="payment-confirmation-loading-message">Carregando...</p>;
    }

    const items = JSON.parse(order.StItems);
    const address = order.Customer?.User?.Address?.[0];
    const transaction = order.OrderTransaction?.slice().sort((a, b) => new Date(b.Created) - new Date(a.Created))[0];

    return (
        <div className="payment-confirmation-page">
            <span
                className="div-center clickable link small-font right-component"
                onClick={() => navigate("/")}
            >
                <ArrowIcon size={12} /> Voltar para a lista de compras
            </span>
            <PageTitle title="Confirmação de Pagamento" />
            
            <div className="status-order">
                <p className={`orders-list-status-label ${
                                            order.OrderStatusId === 1
                                                ? "orders-list-status-paid"
                                                : "orders-list-status-pending"
                                        }`}>
                    {transaction.StAutorization === 'APPROVED' || transaction.StAutorization === 'PAY' ? 'Pedido Pago' : 'Pedido não autorizado'}
                </p>
            </div>

            <div className="payment-div">
                <h3 className="title">Detalhes do Pagamento</h3>
                <div className="payment-details">
                    <p>
                        <strong>Método:</strong>{" "}Cartão de Crédito
                    </p>
                    <p>
                        <strong>Status:</strong> {transaction.StAutorization === 'APPROVED' || transaction.StAutorization === 'PAY' ? 'Pedido Pago' : 'Pedido não autorizado'}
                    </p>
                    <p>
                        <strong>Parcelas:</strong> {transaction.Installments}x
                    </p>
                    <p>
                        <strong>Valor Pago:</strong> R$ {transaction.VlPaid.toFixed(2).replace(".", ",")}
                    </p>
                    <p>
                        <strong>NSU:</strong> {transaction.Nsu}
                    </p>
                </div>
            </div>

            <div className="payment-div">
                <div className="payment-summary">
                    <h3 className="title">Resumo da compra</h3>
                    <p>
                        <strong>{items.length} itens</strong>
                    </p>
                    <p className="payment-summary-total">
                        <strong>Total do pedido</strong>
                        <span>R$ {order.VlnetPrice.toFixed(2).replace(".", ",")}</span>
                    </p>
                </div>
            </div>

            <div className="payment-div">
                <h3 className="title">Itens</h3>
                <div className="payment-items">
                    {items.map((item, index) => (
                        <div key={index} className="payment-item">
                            {item.ISBN ? (
                                <img
                                    src={`https://pwm-public-product-pro.s3.amazonaws.com/${item.ISBN}-large.webp`}
                                    alt="Produto"
                                    className="order-item-image"
                                />
                            ) : (
                                <img
                                    src="https://pwm-public-static-pro.s3.amazonaws.com/static/img/no-cover.png"
                                    alt="Produto"
                                    className="order-item-image"
                                />
                            )}
                            <div className="payment-item-details">
                                <h4>{item.Description}</h4>
                                <p>
                                    <strong>Qtd.</strong> {item.Quantity}{" "}
                                    <span>
                                        R$ {item.UnitPrice.toFixed(2).replace(".", ",")}
                                    </span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {
                address && 
                (<div className="payment-div">
                    <h3 className="title">Endereço</h3>
                    <div className="payment-address-info">
                        <p>
                            {address?.StStreet}, {address?.NrBuildIngsite}
                            {address?.StComplement && `, ${address?.StComplement}`} -{" "}
                            {address?.StNeighborhood}
                        </p>
                        <p>
                            {address?.City ? `${address?.City.Name} - ${address?.City.State}` : ""}
                        </p>
                        <p>{address?.StZipCode}</p>
                    </div>
                </div>)
            }

            <div className="payment-div">
                <h3 className="title">Histórico</h3>
                <div className="payment-history">
                    {order.OrderHistory.map((history, index) => (
                        <div key={index} className="history-item">
                            <p>
                                <strong>{history.Title}</strong>
                            </p>
                            <p>{history.Description}</p>
                            <p>{new Date(history.Created).toLocaleString("pt-BR")}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PaymentConfirmationPage;
